import React, { useState } from "react";
import { validateCareerForm } from "../utils/validation/validate-career";
import { Col, Container, Row } from "react-bootstrap";
import "react-phone-number-input/style.css";
// import { FaBriefcase, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import careerBanner from "../assets/images/careers-banner.png";
import { handleErrors } from "../utils/errorHandler";
import { toast } from "react-toastify";
import careerService from "../services/career-service";
const CareerPage = () => {
  const [formData, setFormData] = useState({
    UserName: "",
    ContactNumber: "",
    EmailAddress: "",
    WorkAvailability: "",
    Locality: "",
    LinkedInProfile: "",
    ExpectedSalary: "",
    Comments: "",
    ResumeFile: null,
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateCareerForm(formData);
    console.log(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
      try {
        const serviceResponse = await careerService.submitCareerForm(formData);

        if (serviceResponse.status === 200) {
          setSubmissionStatus(
            "Thank you for your application! Our team will review your submission!"
          );
          setFormData({
            UserName: "",
            ContactNumber: "",
            EmailAddress: "",
            WorkAvailability: "",
            Locality: "",
            LinkedInProfile: "",
            ExpectedSalary: "",
            Comments: "",
            ResumeFile: null,
          });
        } else {
          throw new Error("Failed to submit the form.");
        }
      } catch (error) {
        let errorMessage = handleErrors(error);
        if (error.response && error.response.status === 500) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  return (
    <>
      <section className="inner-full-banner">
        <div className="banner-img-wrap">
          <img src={careerBanner} alt="" />
        </div>
      </section>
      <section className="pb-0 mt-5">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto">
              <div className="rent-prop-title text-center">
                <h1>Join Our Team at Curenza</h1>
                <p>
                  At Curenza(Omshakthi Monitoring Service Private Limited), we
                  take pride in providing top-quality facility management and
                  maintenance services to businesses and organizations. Our team
                  is dedicated to ensuring clean, safe, and well-maintained
                  environments for our clients.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact-info-sec p-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              {submissionStatus ? (
                <div
                  className={`alert ${
                    submissionStatus.includes("Thank you")
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                  role="alert"
                >
                  {submissionStatus}
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="booking-card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12 col-12">
                          <div className="form-group">
                            <label>Your Name</label>
                            <input
                              type="text"
                              name="UserName"
                              className="form-control"
                              value={formData.UserName}
                              onChange={handleChange}
                            />
                            {errors.UserName && (
                              <div className="text-danger">
                                {errors.UserName}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>Contact Number</label>
                            <input
                              type="phone"
                              maxLength="10"
                              name="ContactNumber"
                              className="form-control"
                              value={formData.ContactNumber}
                              onChange={handleChange}
                            />
                            {errors.ContactNumber && (
                              <div className="text-danger">
                                {errors.ContactNumber}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>Email Address</label>
                            <input
                              type="email"
                              name="EmailAddress"
                              className="form-control"
                              value={formData.EmailAddress}
                              onChange={handleChange}
                            />
                            {errors.EmailAddress && (
                              <div className="text-danger">
                                {errors.EmailAddress}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>Work Availability</label>
                            <select
                              name="WorkAvailability"
                              className="form-control"
                              value={formData.WorkAvailability}
                              onChange={handleChange}
                            >
                              <option value="">Select Availability</option>
                              <option value="Full-time">Immediate</option>
                              <option value="Part-time">30 days</option>
                              <option value="Freelance">60 days</option>
                              <option value="Internship">90 days</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>Location</label>
                            <input
                              type="text"
                              name="Locality"
                              className="form-control"
                              value={formData.Locality}
                              onChange={handleChange}
                            />
                            {errors.Locality && (
                              <div className="text-danger">
                                {errors.Locality}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>LinkedIn Profile</label>
                            <input
                              type="text"
                              name="LinkedInProfile"
                              className="form-control"
                              value={formData.LinkedInProfile}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-12">
                          <div className="form-group">
                            <label>Expected Salary </label>
                            <input
                              type="text"
                              name="ExpectedSalary"
                              className="form-control"
                              value={formData.ExpectedSalary}
                              onChange={handleChange}
                            />
                            {errors.ExpectedSalary && (
                              <div className="text-danger">
                                {errors.ExpectedSalary}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Message</label>
                            <textarea
                              name="Comments"
                              className="form-control"
                              rows="5"
                              value={formData.Comments}
                              onChange={handleChange}
                            ></textarea>
                            {errors.Comments && (
                              <div className="text-danger">
                                {errors.Comments}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12 mb-3">
                          <label>Upload Resume </label>
                          <div
                            style={{
                              border: "1px dashed #868686",
                              padding: "10px",
                              textAlign: "center",
                              borderRadius: "5px",
                            }}
                          >
                            <input
                              type="file"
                              name="ResumeFile"
                              className="form-control"
                              onChange={handleFileChange}
                              style={{ display: "none" }}
                              id="resumeUpload"
                            />
                            <label
                              className="mb-0 resume-upload"
                              htmlFor="resumeUpload"
                              style={{ cursor: "pointer" }}
                            >
                              {!formData.ResumeFile && (
                                <p className="mt-0 mb-0">
                                  + Add or Drop Files Here
                                </p>
                              )}
                              {formData.ResumeFile && (
                                <p className="mt-2">
                                  {formData.ResumeFile.name}
                                </p>
                              )}
                            </label>
                            {errors.ResumeFile && (
                              <div className="text-danger">
                                {errors.ResumeFile}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn orange-btn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareerPage;
